<template>  
  <v-slide-y-transition mode="out-in">
    <v-container grid-list-xl fluid class="ma-0">
      <v-layout row wrap>
        <v-flex xs12>
          <v-tabs
            color="grey lighten-3"            
            v-model="tab"            
            grow
            slider-color="blue"
          >
            <v-tabs-slider color="yellow" height="30"></v-tabs-slider>

            <v-tab
              v-for="(item, i) in tabs"
              :key="item.id"
              :class="tab==i ?'blue white--text':''"
            >
              {{ matpelName(item.name) }}
            </v-tab>
          </v-tabs>
          <v-progress-linear class="ma-0 pa-0" :indeterminate="true" v-if="loading"></v-progress-linear>
        </v-flex>
        <template v-if="!allowmulai && !loading">
          <v-flex xs12>
            <v-card v-if="jilid.time_start">
              <v-card-text>
                <p class="text-xs-center">
                  Ujian untuk mata pelajaran ini akan dimulai pada <strong>{{$moment(jilid.time_start*1000).format('LLL')}}</strong>
                </p>
              </v-card-text>
              <v-card-text >
                <h4 class="orange--text text-xs-center headline">Hitungan Mundur Pelaksanaan Ujian</h4>
                <base-timer :eventEnd="jilid.time_start" v-on:finish="setAllowmulai()" class="mx-auto" />                          
              </v-card-text>
              <v-card-text>
                <v-alert type="error" outline value="true" style="max-width:400px">
                  Mohon Perhatian : Jangan masuk kehalaman ini jika <strong>hari ini</strong> bukan jadwal ujian ananda. klik tombol dibawah untuk kembali                  
                </v-alert>
                 <v-btn color="success" round :to="{name:'dashboard'}"><v-icon left>keyboard_backspace</v-icon> Kembali Ke Portal</v-btn>
              </v-card-text>
            </v-card>
          </v-flex>
        </template>
        <template v-else-if="allowmulai && !dtab.mulai && !dtab.selesai">
          <v-flex xs12>
            <v-card>
              <v-card-text>
                <p class="text-xs-center">
                  <v-alert :value="true" type="warning">
                    Dengan mengklik button buka soal maka waktu ujian akan dimulai. pastikan ananda dalam keadaan siap.
                  </v-alert>
                  Klik button dibawah untuk membuka soal.                   
                  <br/>
                  <v-btn color="primary" class="mt-4" round @click="dtab.mulai = true; tabs[tab].mulai = true; refresh()" large><v-icon left>start</v-icon> Buka Soal</v-btn>
                </p>
              </v-card-text>              
            </v-card>
          </v-flex>
        </template>
        <template v-else-if="!loading">
          <template v-if="dtab.selesai">
            <v-flex xs12>
              <v-card>
                <v-card-text class="text-xs-center pa-0">
                  <v-alert type="info" value="true">
                    <h1>Terima Kasih, Ananda telah selesai mengikuti mata ujian ini</h1>
                    <h3>Pastikan ananda telah mengikuti seluruh rangkaian ujian online.</h3>                    
                  </v-alert>
                </v-card-text>
                <v-card-actions>
                  <v-btn color="success" text flat round :to="{name:'dashboard'}"><v-icon left>keyboard_backspace</v-icon> Kembali Ke Portal</v-btn>
                  <v-spacer />                  
                </v-card-actions>
              </v-card>
            </v-flex>
          </template>     
          <template v-else>      
            <v-flex xs12 md3>
              <v-card class="mb-4">
                <v-toolbar dense flat>
                  <v-toolbar-title>Informasi</v-toolbar-title>
                </v-toolbar>            
                <v-card-text>
                  <table style="width:100%;">
                    <tbody>
                      <tr>
                        <td>ID</td>
                        <td>:</td>
                        <td>{{fm.id}}</td>
                      </tr>
                      <tr>
                        <td>Nama</td>
                        <td>:</td>
                        <td>{{fm.nama}}</td>
                      </tr>
                      <tr>
                        <td>Nomor</td>
                        <td>:</td>
                        <td>{{fm.calonGedung.number}}</td>
                      </tr>
                      <tr>
                        <td>Mata Uji</td>
                        <td>:</td>
                        <td>{{matpelName(dtab.name)}}</td>
                      </tr>
                      <tr>
                        <td>Jumlah Soal</td>
                        <td>:</td>
                        <td>{{totalSoal}}</td>
                      </tr>
                      <tr>
                        <td>Waktu Ujian</td>
                        <td>:</td>
                        <td>{{jilid.waktu}} menit</td>
                      </tr>
                    </tbody>
                  </table>  
                  <template v-if="finishtime">
                    <h1 class="text-xs-center mt-4 mb-2 title">Sisa Waktu</h1>
                    <base-timer2 :eventEnd="finishtime" :eventStart="startime" v-on:finish="setSelesai()" class="mx-auto" />
                  </template>
                </v-card-text>
              </v-card> 
              <v-card>
                <v-toolbar dense flat>
                  <v-toolbar-title>Nomor Soal</v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                  <table class="table-border" style="width:100%;">
                    <tbody>
                      <tr v-for="(row, j) in nosoal" :key="'row'+j">
                        <td v-for="(col, k) in row" :key="'col'+k" 
                          :class="stepke == col.no ? 'cyan white--text': (m=fm.responDtls.find(x=>x.no==col.no)) && m.answer_id ? 'green white--text':''"
                          style="width:10%"
                          @click="stepke=col.no; saveAngket()"
                          >
                          {{col.no}}
                        </td>
                      </tr>
                    </tbody>               
                  </table>              
                </v-card-text>
                <v-card-text>
                  <v-chip small color="cyan"></v-chip> Sedang dikerjakan<br/>
                  <v-chip small color="green"></v-chip> Sudah dijawab<br/>
                  <v-chip small color="grey lighten-3"></v-chip> Belum dijawab
                </v-card-text>
              </v-card> 
            </v-flex>
            <v-flex xs12 md9>
              <v-card>
                <v-card-text class="pa-0">              
                  <v-stepper elevation="0" :value="stepke" v-if="Array.isArray(fm.responDtls) && fm.responDtls.length>0">
                    <v-stepper-items  elevation="0">                  
                      <v-stepper-content v-for="(item, i) in fm.responDtls" :key="'soal'+i" :step="i+1" >
                        <v-layout text-xs-center class="pa-4" wrap>
                          <img v-if="item.image" :src="$config.url+'cdn/img/questionnaire/'+item.image" />
                        </v-layout>
                        <br/>
                        <v-chip color="cyan" dark class="ma-0 mr-2" large>{{i+1}}</v-chip>                      
                        <span v-html="item.question"></span>
                        <p style="padding-left:30px;" class="mt-3">               
                          <template v-if="item.type === 1">
                            <v-radio-group v-model="item.answer_id" hide-details class="mt-0">
                              <v-radio v-for="(opt,n) in item.option" :key="n"
                                :label="opt.key+'. '+opt.value" :value="parseInt(opt.id)"
                              ></v-radio>
                            </v-radio-group>
                          </template>
                          <template v-else-if="item.type === 2">
                            <v-checkbox v-for="(opt,n) in item.option" v-model="item.answer_jsonid[n]" :key="n" class="mt-1" :label="opt.key+'. '+opt.value" :value="opt.id" hide-details></v-checkbox>            
                          </template>
                          <template v-else-if="item.type === 3">
                            <v-text-field v-for="(opt,n) in item.option" v-model="item.answer_jsonvalue[n]" :key="n" type="text" :label="opt.key" small hide-details style="max-width:400px;margin-bottom:4px;" >
                              <span :set="item.answer_jsonkey[n] = opt.key"></span>
                            </v-text-field>
                          </template>     
                        </p>                 
                      </v-stepper-content>                  
                    </v-stepper-items>                
                    <v-card-actions class="pa-4">
                      <v-btn small color="warning" v-if="stepke > 1" class="pa-1" @click="stepke=stepke-1; saveAngket()">Sebelumnya</v-btn>
                      <v-spacer></v-spacer>
                      <v-btn small color="success" v-if="stepke < totalSoal" class="pa-1" @click="stepke=stepke+1; saveAngket()">Selanjutnya</v-btn>
                      <v-btn color="primary" v-else class="pa-1" @click="submitSelesai()">Selesai</v-btn>
                    </v-card-actions>
                  </v-stepper>
                </v-card-text>            
              </v-card>  
            </v-flex>
          </template>  
        </template>  
      </v-layout>
             
    </v-container>
  </v-slide-y-transition> 
</template>
<script>
import BaseTimer from "@/views/dashboard/components/BaseTimer";
import BaseTimer2 from "@/views/dashboard/components/BaseTimer2";
import User  from '@/util/models/User';
import Model from '@/models/dashboard';
const  model = new Model();

export default {
  components: {
    BaseTimer, BaseTimer2
  },
  data:()=>({    
    tab : null,
    tabs : [],
    dtab : {
      mulai : false,
      selesai : false,
    },
    user : User.attributes(), 
    jilid:{}, nosoal:[],
    tingkat_id:null,
    fm:{
      nama:null,
      responDtls:[]
    },
    stepke:0,
    totalSoal:0,
    loading:false,
    allowmulai:false,
    ismulai:false,
    selesai: false,
    nomor_ujian:null,
    nomor_ujian_error:false,
    loadingCekNomorUjian:false,
    finishtime:null, startime:null,
  }),
  watch:{    
    'tab'(ntab, otab){
      if(otab !== null){
        this.saveAngket(true)
      }      
      Object.assign(this.dtab,this.tabs[ntab]);      
      if(this.dtab){
        //this.dtab.selesai = true;        
        this.allowmulai = false
        this.init('ujian_'+this.tingkat_id+'_'+this.dtab.name.toLowerCase())
      }      
    }
  },
  computed: {    

  }, 
  mounted(){    
    User.reset()
    this.loading = true;
    model.viewAdministrasi({id:this.user.id}).then(data=>{        
      Object.assign(this.fm, data);
      this.loading = false;
      this.tingkat_id = this.fm.tingkat_id <= 2 ? this.fm.tingkat_id : this.fm.jurusan_id
      let dkey = 'ujian_'+this.tingkat_id
      model.settings({key:dkey}).then(res=>{
        this.tabs = res.value.map((d)=>{
          d = {...d,...{finish:false,mulai:false}}
          return d
        });     

        this.tab = 0   
      })      
    });        
  },
  methods : {    
    setAllowmulai(){
      this.allowmulai = true
      //this.init('ujian_'+this.tingkat_id+'_'+this.dtab.name.toLowerCase())
    },
    
    refresh(){
      this.init('ujian_'+this.tingkat_id+'_'+this.dtab.name.toLowerCase())
    },

    setSelesai(){
      this.saveAngket(true, true)
      this.dtab.selesai = true
    },

    submitSelesai(){
      this.$swal({
        title: 'Apakah Ananda Yakin ?', 
        text: "Setelah ini Ananda tidak dapat melnjutkan ujian untuk mata pelajaran ini.",  
        type: 'warning',
        showCancelButton: true, 
        confirmButtonColor: '#3085d6', 
        cancelButtonColor: '#d33', 
        confirmButtonText: 'Ya, Selesai Ujian'}).then((result) => {                 
        if (result.value) { 
          this.saveAngket(true, true)
          this.dtab.selesai = true
        }
      });      
    },    

    init(questionKey){
      this.loading = true
      
      model.soalUjian({expand:'quetionnaires,responDtls,ujians', key:questionKey}).then(jilid=>{         
        this.loading = false
        this.fm.jilid_id = jilid.id
        this.jilid = jilid;     
        if((this.$moment().valueOf()/1000) > this.jilid.time_start){
          this.allowmulai = true;
        }           
        this.startime   = this.$moment().valueOf()
        this.finishtime = this.$moment().add(this.jilid.waktu, 'minutes').valueOf()
        this.dtab.selesai = false;
        if(this.jilid && this.jilid.ujians && Array.isArray(this.jilid.ujians) && this.jilid.ujians.length > 0){          
          let ujian = this.jilid.ujians.find(x => x && x.id == this.dtab.id);
          if(ujian && ujian.startime){                     
            this.startime   = parseFloat(ujian.startime);
            this.finishtime = this.$moment(this.startime).add(this.jilid.waktu, 'minutes').valueOf()
            if(this.finishtime < this.$moment().valueOf() || ujian.isfinish == true ||  ujian.isfinish == "true"){
              this.dtab.selesai = true;
            } else {
              this.dtab.selesai = false;
            }
          }
        }

        this.fm.responDtls = [];
        this.jilid.quetionnaires.forEach(item=>{         
          let question = jilid.responDtls.find(x=>x.quetionnaire_id == item.id);
          if(question){
            question.jilid_id = this.jilid.id;
            question.no = item.no;
            question.type = item.type;
            question.question = item.question;
            question.option = item.option;     
            question.image = item.image;     
            question.answer_id = question.answer_id ? parseInt(question.answer_id):question.answer_id;
            this.fm.responDtls.push(question);              
          } else {
            this.fm.responDtls.push({
              quetionnaire_id:item.id,
              jilid_id:this.jilid.id,
              no:item.no,
              type:item.type,
              question:item.question,
              option:item.option,
              image:item.image,
              answer_id:null,
              answer_key:null,
              answer_value:null,
              answer_jsonid:[],
              answer_jsonkey:[],
              answer_jsonvalue:[]
            })
          }           
        });  
        this.getNosoal()
      });
    },

    saveAngket(saveas=false, finish=false){
      //this.loading = true;
      model.saveUjian(this.fm, {
        jilid_id:this.jilid.id,
        saveas:saveas,
        finish:finish,
        startime:this.startime,
        matpelid:this.dtab.id
      }).then(res=>{                
        //this.loading = false;
      });
    },

    getNosoal(){
      if(Array.isArray(this.fm.responDtls)){
        this.totalSoal = this.fm.responDtls.length
        let row = 0;
        this.nosoal = [];
        for(var i=1; i<=this.totalSoal; i++){        
          if(i == 1){
            this.nosoal.push([])
            this.nosoal[row].push({no:i});            
          } else if(i%10==0){
            this.nosoal[row].push({no:i});
            this.nosoal.push([])            
            row++;
          } else {
            this.nosoal[row].push({no:i});
          }        
        }        
        this.stepke = 1        
      }             
    },

    matpelName(key){    
      switch(key.toLowerCase()){
        case 'math':
          return 'Matematika'; break          
        case 'barab':  
          return 'B. Arab'; break          
        case 'bing':  
          return 'B. Inggris'; break          
        default :
          return key; break
      }
    }
  }
};
</script>
<style>
.table-border {
  border-collapse: collapse;
}

.table-border th, .table-border td {
  padding: 5px 0;
  border: 1px solid black;
  text-align:center;
  cursor:pointer;
}

.table-border td:hover {
  background: #eee;
}
</style>


